import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { Department } from 'src/app/models/department.model';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { DepartmentService } from 'src/app/services/department.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-add-department-category-dialog',
  templateUrl: './add-department-category-dialog.component.html',
  styleUrls: ['./add-department-category-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatIcon,
  ],
})
export class AddDepartmentCategoryDialogComponent implements OnInit {
  protected fb = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<AddDepartmentCategoryDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private api = inject(ApiService);
  protected activatedRoute = inject(ActivatedRoute);
  private departmentService = inject(DepartmentService);

  categoryForm: UntypedFormGroup;
  departments: Department[];

  constructor() {
    const data = this.data;

    this.departments = data.departments;
    this.categoryForm = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      description: ['', Validators.compose([Validators.required])],
      //num_employees: ['', Validators.compose([Validators.required])],
      min_salary: ['', Validators.compose([Validators.required])],
      max_salary: ['', Validators.compose([Validators.required])],
      department_id: [data.department_id, Validators.compose([Validators.required])],
    });
  }

  ngOnInit(): void {}

  cancel(): void {
    this.dialogRef.close();
  }

  checkValue(event: any) {}
}
